import React from 'react'
import ClassNames from 'classnames'
import {
  TableStyle,
  TableRowStyle,
  TableColumnStyle,
  TableColumnHeadStyle,
  TBodyStyle,
  THeadStyle,
  TFootStyle,
} from './styled'

import { Image } from '../../components'
import { ICONS } from '../../themes'

/**
 * Table description
 * - ...
 */

class TBody extends React.PureComponent {
  render() {
    const { children } = this.props

    return (
      <TBodyStyle {...this.props} className="tbody">
        {children}
      </TBodyStyle>
    )
  }
}

class THead extends React.PureComponent {
  render() {
    const { children } = this.props

    return (
      <THeadStyle {...this.props} className="thead">
        {children}
      </THeadStyle>
    )
  }
}

class TFoot extends React.PureComponent {
  render() {
    const { children } = this.props

    return (
      <TFootStyle {...this.props} className="tfoot">
        {children}
      </TFootStyle>
    )
  }
}

class TableColumnHead extends React.PureComponent {
  renderSortClass = sortBy => {
    switch (sortBy) {
      case 'desc':
        return 'is-desc'
      case 'descending':
        return 'is-desc'
      case 'asc':
        return 'is-asc'
      case 'ascending':
        return 'is-asc'
      default:
        break
    }
  }

  render() {
    const { className, children, id, isSortable, sortBy, onClick } = this.props

    return (
      <TableColumnHeadStyle
        {...this.props}
        className={ClassNames(
          'table-column-head',
          { 'is-sortable': isSortable },
          this.renderSortClass(sortBy),
          className
        )}
        onClick={isSortable ? onClick : undefined}
        id={id}
      >
        {children}
        {isSortable && (
          <Image src={ICONS['icon-chevron-down.svg']} className="sort-icon" />
        )}
      </TableColumnHeadStyle>
    )
  }
}

class TableColumn extends React.PureComponent {
  render() {
    const { className, children, id, style } = this.props

    return (
      <TableColumnStyle
        {...this.props}
        className={ClassNames('table-column', className)}
        id={id}
        style={style}
      >
        {children}
      </TableColumnStyle>
    )
  }
}

class TableRow extends React.PureComponent {
  render() {
    const { className, children, id, data_index_number } = this.props
    return (
      <TableRowStyle
        className={ClassNames('table-row', className)}
        id={id}
        data-index-number={data_index_number}
      >
        {children}
      </TableRowStyle>
    )
  }
}

export class DivTable extends React.PureComponent {
  static TH = TableColumnHead
  static TD = TableColumn
  static TR = TableRow
  static TBODY = TBody
  static THEAD = THead
  static TFOOT = TFoot

  render() {
    const {
      className,
      children,
      id,
      isScrollbar,
      tableWidth,
      tableHeight,
    } = this.props

    return (
      <TableStyle
        className={ClassNames({ 'is-scrollbar': isScrollbar }, className)}
        setWidth={tableWidth}
        setHeight={tableHeight}
      >
        <div className="table" id={id}>
          {children}
        </div>
      </TableStyle>
    )
  }
}

TableColumnHead.defaultProps = {
  isSortable: false,
}
TableRow.defaultProps = {
  data_index_number: '',
}
TableColumn.defaultProps = {
  style: {},
}
